/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IngredientRecipeModalCreateMutationVariables = {|
  ingredient: string,
  recipe: string,
  unity?: ?string,
  qty?: ?string,
  comments?: ?string,
  fraction?: ?string,
|};
export type IngredientRecipeModalCreateMutationResponse = {|
  +recipeIngredientCreate: ?{|
    +recipe: ?{|
      +ingredient: {|
        +id: string,
        +name: string,
      |}
    |}
  |}
|};
export type IngredientRecipeModalCreateMutation = {|
  variables: IngredientRecipeModalCreateMutationVariables,
  response: IngredientRecipeModalCreateMutationResponse,
|};
*/


/*
mutation IngredientRecipeModalCreateMutation(
  $ingredient: String!
  $recipe: ID!
  $unity: ID
  $qty: String
  $comments: String
  $fraction: String
) {
  recipeIngredientCreate(input: {ingredient: $ingredient, recipe: $recipe, unity: $unity, qty: $qty, comments: $comments, fraction: $fraction}) {
    recipe {
      ingredient {
        id
        name
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ingredient",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recipe",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unity",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "qty",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "comments",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fraction",
    "type": "String"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "comments",
        "variableName": "comments"
      },
      {
        "kind": "Variable",
        "name": "fraction",
        "variableName": "fraction"
      },
      {
        "kind": "Variable",
        "name": "ingredient",
        "variableName": "ingredient"
      },
      {
        "kind": "Variable",
        "name": "qty",
        "variableName": "qty"
      },
      {
        "kind": "Variable",
        "name": "recipe",
        "variableName": "recipe"
      },
      {
        "kind": "Variable",
        "name": "unity",
        "variableName": "unity"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "IngredientNode",
  "kind": "LinkedField",
  "name": "ingredient",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IngredientRecipeModalCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeIngredientCreatePayload",
        "kind": "LinkedField",
        "name": "recipeIngredientCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNode",
            "kind": "LinkedField",
            "name": "recipe",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IngredientRecipeModalCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeIngredientCreatePayload",
        "kind": "LinkedField",
        "name": "recipeIngredientCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNode",
            "kind": "LinkedField",
            "name": "recipe",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "IngredientRecipeModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation IngredientRecipeModalCreateMutation(\n  $ingredient: String!\n  $recipe: ID!\n  $unity: ID\n  $qty: String\n  $comments: String\n  $fraction: String\n) {\n  recipeIngredientCreate(input: {ingredient: $ingredient, recipe: $recipe, unity: $unity, qty: $qty, comments: $comments, fraction: $fraction}) {\n    recipe {\n      ingredient {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ffdf82daad20acbe9c85e65263610f8d';

module.exports = node;
